const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

const request = async (path, opts = {}) => {
  const { headers: extraHeaders, body, ...rest } = opts;
  const res = await fetch(`${API_BASE}/api/support${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(extraHeaders || {}) },
    ...rest,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = res.statusText;
    let code = null;
    try {
      const j = await res.json();
      msg = j.message || j.error || msg;
      code = j.error || null;
    } catch {}
    const err = new Error(msg);
    err.status = res.status;
    err.code = code;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
};

export const listMyTickets        = () => request("/my-tickets");
export const getMyUnreadCount     = () => request("/my-tickets/unread-count");
export const getMyTicket          = (id) => request(`/${id}`);
export const listMyTicketMessages = (id) => request(`/${id}/messages`);
export const postMyTicketMessage  = (id, body) => request(`/${id}/messages`, { method: "POST", body: { body } });
export const reopenMyTicket       = (id) => request(`/${id}/reopen`, { method: "POST" });
export const createTicket         = (body) => request(`/ticket`, { method: "POST", body });
